module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v("Profil von " + _vm._s(_vm.model.model.firstname) + " " + _vm._s(_vm.model.model.lastname))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("Zurück")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Allgemeine Informationen  "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/users/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Vorname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.firstname),
      expression: "model.model.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "firstname",
      "name": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.firstname = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Nachname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.lastname),
      expression: "model.model.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "lastname",
      "name": "lastname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.lastname = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Loginname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.username),
      expression: "model.model.username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "name": "username",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.username = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Passwort")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.password),
      expression: "model.model.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "name": "password",
      "type": "password",
      "placeholder": _vm.model.model.id === 0 ? 'Passwort eingeben' : '[Nicht ändern]',
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.password = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "repassword"
    }
  }, [_vm._v("Passwort wiederholen")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.repassword),
      expression: "model.model.repassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "repassword",
      "name": "password",
      "type": "password",
      "placeholder": _vm.model.model.password === '' ? '[Nicht ändern]' : 'Passwort wiederholen',
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.repassword = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "superior"
    }
  }, [_vm._v("Vorgesetzter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.superior_name),
      expression: "model.model.superior_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "superior",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.superior_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.superior_name = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Rolle")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.role_name),
      expression: "model.model.role_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "role",
      "name": "role",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.role_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.role_name = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.updateProfile()
      }
    }
  }, [_vm._v("Speichern")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "addresses"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.addresses.cols,
      "src-model": _vm.model.addresses,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addAddress,
      "edit": _vm.editAddress,
      "delete": _vm.deleteAddress
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "contacts"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.contacts.cols,
      "src-model": _vm.model.contacts,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addContact,
      "edit": _vm.editContact,
      "delete": _vm.deleteContact
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('custom-modal', {
    ref: "addressModal",
    attrs: {
      "title": "Adresse hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('address-content', {
    ref: "newAddress"
  })], 1), _vm._v(" "), (_vm.visibleModal === 'deleteaddresses') ? _c('custom-modal-old', {
    attrs: {
      "title": "Adresse löschen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-primary",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('addresses')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diese Adresse entfernen möchten?")])]) : _vm._e(), _vm._v(" "), _c('custom-modal', {
    ref: "contactModal",
    attrs: {
      "title": "Kontakt hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('contact-content', {
    ref: "newContact"
  })], 1), _vm._v(" "), (_vm.visibleModal === 'deletecontacts') ? _c('custom-modal-old', {
    attrs: {
      "title": "Kontakt entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('contacts')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'errSavingModel') ? _c('custom-modal-old', {
    attrs: {
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\r\n\t\t\tFehler beim Speichern des Kunden.\r\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'incorrectPassword') ? _c('custom-modal-old', {
    attrs: {
      "title": "Fehler",
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\r\n\t\t\tPasswörter stimmen noch nicht überein.\r\n\t\t")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#addresses"
    }
  }, [_vm._v("Adressen")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#contacts"
    }
  }, [_vm._v("Kontakte")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb3d77ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
// module id = 464
// module chunks = 0